var render = function render(){var _vm=this,_c=_vm._self._c;return _c('l-layout',{attrs:{"layout":['xs12']}},[_c('l-data-table',{attrs:{"get-data-func":_vm.getBillList,"title-text":"账单列表","clickable":"","headers":_vm.header},on:{"click:row":function($event){return _vm.getDetails($event.item)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }